import { makeStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import MicIcon from '@material-ui/icons/Mic';
import MicOffIcon from '@material-ui/icons/MicOff';
import ScreenShareIcon from '@material-ui/icons/ScreenShare';
import StopScreenShareIcon from '@material-ui/icons/StopScreenShare';
import VideocamIcon from '@material-ui/icons/Videocam';
import VideocamOffIcon from '@material-ui/icons/VideocamOff';
import VideoStatus from 'enums/VideoStatus';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toggleMuteSelfAction } from 'store/classroom/classroomActions';
import { toggleVideoAction } from 'store/video/videoActions';

const useStyles = makeStyles((theme) => ({
  deviceBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: theme.palette.background.light,
    color: theme.palette.primary.main,
    width: '50%',
    margin: '0 auto',
    ...theme.mixins.borderRadius(),
    ...theme.mixins.shadow(),
    '& > *': {
      margin: '1rem 0',
      fontSize: '200%',
      cursor: 'pointer',
      '&[disabled]': {
        opacity: 0.75,
        color: '#777',
        cursor: 'not-allowed',
      },
      '&[data-im-sharing="1"]': {
        color: 'red',
      },
    },
  },
}));

const displayMediaOptions = {
  video: {
    cursor: 'always',
  },
  audio: true,
};

export default function PresenterDevices() {
  const classes = useStyles();
  const { attendeeId, videoStatus, muted, audioVideo, contentTile, contentSharerId } = useSelector(
    ({ video, chime }) => ({
      attendeeId: chime.attendeeId,
      videoStatus: video.videoStatus,
      muted: video.muted,
      audioVideo: chime.audioVideo,
      contentTile: video.contentTile,
      contentSharerId: video.contentSharerId,
    })
  );
  const dispatch = useDispatch();

  const userIsSharing = !!contentTile?.id;
  const localUserIsSharing = contentSharerId === attendeeId + '#content';

  const toggleMute = () => {
    dispatch(toggleMuteSelfAction());
  };

  const toggleVideo = () => {
    dispatch(toggleVideoAction());
  };

  const toggleScreenShare = async () => {
    if (userIsSharing) {
      if (localUserIsSharing) {
        await audioVideo.stopContentShare();
      }

      return;
    }

    try {
      const captureStream = await navigator.mediaDevices.getDisplayMedia(displayMediaOptions);
      await audioVideo.startContentShare(captureStream);
    } catch (err) {
      console.error('Error: ' + err);
    }
  };

  const VideoIconToUse = videoStatus === VideoStatus.Enabled ? VideocamIcon : VideocamOffIcon;
  const MicIconToUse = muted ? MicOffIcon : MicIcon;
  const ScreenShareIconToUse =
    userIsSharing && localUserIsSharing ? StopScreenShareIcon : ScreenShareIcon;
  return (
    <div className={classes.deviceBox}>
      <Tooltip title="Toggle video">
        <VideoIconToUse onClick={toggleVideo} id="presenter-video-toggle" />
      </Tooltip>
      <Tooltip title="Toggle microphone">
        <MicIconToUse onClick={toggleMute} id="presenter-mic-toggle" />
      </Tooltip>
      <Tooltip title="Toggle screen share">
        <ScreenShareIconToUse
          onClick={toggleScreenShare}
          data-im-sharing={localUserIsSharing ? 1 : 0}
          disabled={userIsSharing && !localUserIsSharing}
        />
      </Tooltip>
    </div>
  );
}
